import { parse, isValid } from 'date-fns';

export function stringSortCompare(inputA: string, inputB: string, direction: 'asc' | 'desc' = 'asc') {
  let a = inputA.toLowerCase();
  let b = inputB.toLowerCase();

  if (a === b) {
    a = inputA;
    b = inputB;
  }

  let result = a.localeCompare(b, undefined, { numeric: true });

  if (direction === 'desc') {
    result *= -1;
  }

  return result;
}

export function numberSortCompare(inputA: number, inputB: number, direction: 'asc' | 'desc' = 'asc') {
  let result = inputA - inputB;

  if (direction === 'desc') {
    result *= -1;
  }

  return result;
}

export function dateSortCompare(inputA: string, inputB: string, direction: 'asc' | 'desc' = 'asc'): number {
  const dateA = parse(inputA, "yyyy-MM-dd'T'HH:mm:ss.SSSX", new Date());
  const dateB = parse(inputB, "yyyy-MM-dd'T'HH:mm:ss.SSSX", new Date());

  if (!isValid(dateA) || !isValid(dateB)) {
    throw new Error('Invalid date format');
  }

  const result = dateA.getTime() - dateB.getTime();

  return direction === 'asc' ? result : -result;
}
